export const getEndpointPath =
  (service: string, controller: string) => (endpoint: string) => {
    return `${service}/${controller}/${endpoint}`;
  };
